const project = {
  en: {
    project: {
      form: {
        enableProject: {
          title: "Enable project to analysis",
          fields: {
            projects: {
              label: "Projects",
              noResults: "No projects were found. Consider changing the search.",
              placeholder: "Select a project"
            }
          },
          actions: {
            enable: "Enable"
          }
        },
        add_coder: {
          title: "Add Coder",
          save: "Add Coder"
        },
        select_state: "Select a state",
        configuration: {
          article_summary: "Include Article Summary",
          auto_translation: "Add english translation to all non-english articles",
          auto_en_translation: "Translate Headlines",
          auto_publish: "Auto-publish coded articles",
          use_outlet_circulation: "Use current outlet circulation on Query Engine",
          organizations_with_category: "Use Organizations with Categories",
          import_tags_from_insight: "Import tags from Insight",
          ave_for_social: "Calculate AVE for Social",
          ave_for_social_info: "Do not use for CARMA clients - requires IT authorization via Support ticket.",
          load_more: "Load More",
          organizations: "Organizations",
          display_automated_tags: "Display Insight tags on Query Engine",
          auto_approve_tags: "Auto-Approve new tags",
          auto_approve_authors: "Auto-Approve new authors",
          scoring: "Scoring System",
          display_social_metrics: "Display social metrics on Query Engine",
          tooltip_display_social_metrics: "Enables engagements metrics such as Likes, Reposts to QB as output metrics",
          enable_socials_data: "Enable social data",
          tooltip_enable_socials_data: "Enables set of social metrics in article list view, QB and Exports",
          tooltip_auto_translation: "Please send a ticket to IT support to toggle this option",
          tooltip_auto_en_translation: "Enables automatic English translation of headlines, applicable only to content with a Coded or Published status",
          auto_relevancy: "AI relevancy",
          auto_coder: "AI coding",
          tooltip_auto_coder: "Enabling this feature also requires a model created by the R&D team, please get in touch via IT support if you have any questions",
          general_settings: "General settings",
          automated_tags: "Automated Tags / Sentiment",
          social_data: "Social Data",
          ai_gpt: "AI / GPT",
          tooltip_import_tags_from_insight: "Imports Insight tags, including private tags, onto PC articles. This can be triggered manually and ensures Insight tags are refreshed in Project Code",
          auto_ai_summary: 'Generate AI Summary',
          tooltip_auto_ai_summary: 'Please insert Prompt on AI Summary tab on Bohdi in order to activate this toggle'
        }
      },
      message: {
        expired: "Expired",
        expired_on: "Expired on",
        published_disable_change_coder: "It is not possible to change the coder for published projects.",
        unassigned_disable_open_editor: "Unassigned project can't open editor",
        unassigned_cant_change_status: "Unassigned project can't change status to Published",
        view_project: "View Project"
      }
    }
  }
}

module.exports.project = project;